module.exports = __webpack_public_path__ + "img/icon_plus.32bfe578.svg";